export default "__VITE_ASSET__CvLO1M8L__"